import { CommercialLoadAxleModel } from './commercial-axles.model';
import { CommercialLoadModel } from './commercial-load.model';
import { CommercialPermitNumberModel } from './commercial-permit-number.model';
import { CommercialTrailerModel } from './commercial-trailer.model';
import { CommercialTripModel } from './commercial-trip.model';

export class CommercialPermitTransactionModel {
    public customerNumberId: number;
    public permit: CommercialPermitNumberModel;
    public commercialTrailers: CommercialTrailerModel[];
    public commercialTrip: CommercialTripModel;
    public commercialLoad: CommercialLoadModel;
    public commercialLoadAxles: CommercialLoadAxleModel[];
}
